'use client';
import type { SiteBanner } from '../lib/site';
import { BnSlider } from './BnSlider';
import { Img } from './PageBanners';

/**
 * 배너 조각 — 서버가 노출 판정(사용·기간)을 끝낸 것을 받아 그리기만 한다.
 * 링크가 없으면 그림만 보여 준다(현행은 "준비 중" alert 였는데, 누를 수 없는 것을
 * 누르게 두는 쪽이 이상하다 — 링크 없는 배너는 <a> 를 만들지 않는다).
 */
function BannerLink({ b, children }: { b: SiteBanner; children: React.ReactNode }) {
  if (!b.link) return <>{children}</>;
  return <a href={b.link} target={b.openNewWindow ? '_blank' : undefined} rel="noreferrer">{children}</a>;
}

/**
 * 메인 구성의 배너 줄(N 섹션) — 1장이면 그대로, **여러 장이면 자동 슬라이더**
 * (2026-08-21 재확정 — 현행 인덱스 배너 슬라이드 계승. 순서는 배너 관리의 노출 순서).
 * PC·모바일 이미지는 가이드 공통 규약(bn-img-pc/bn-img-mo — 768px 경계 CSS)으로 가른다.
 */
export function MainBannerStrip({ banners }: {
  banners: Array<Pick<SiteBanner, 'id' | 'title' | 'link' | 'openNewWindow' | 'imagePc' | 'imageMobile'>>;
}) {
  const rows = banners.filter((b) => b.imagePc || b.imageMobile);
  if (!rows.length) return null;
  if (rows.length === 1) return <div className="bn-slider-unit"><div className="bn-slide"><Img b={rows[0] as SiteBanner} /></div></div>;
  return <BnSlider>{rows.map((b) => <Img key={b.id} b={b as SiteBanner} />)}</BnSlider>;
}
